import { render } from "./TagStandard.vue?vue&type=template&id=a6dff804&scoped=true"
import script from "./TagStandard.vue?vue&type=script&lang=js"
export * from "./TagStandard.vue?vue&type=script&lang=js"

import "./TagStandard.vue?vue&type=style&index=0&id=a6dff804&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6dff804"]])

export default __exports__